import {Fragment} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {showNotification} from "../../../../actions";
import {defineMessage} from "react-intl";
import {useDispatch} from "react-redux";
import {useBoolState, ConfirmDialog} from "@dvrt/graphql-widgets";
import {useDeleteClientDeviceMutation} from "../queries.generated";
import {CONFIRM_MESSAGES} from "@/utils/translations";

type Props = {
    id: number;
    onSuccess: () => void;
    name: string;
    dataIdentifier: string;
};

export default ({id, onSuccess, name, dataIdentifier}: Props) => {
    const [isOpen, open, close] = useBoolState();
    const [mutation] = useDeleteClientDeviceMutation();
    const dispatch = useDispatch();

    async function mutate() {
        const response = await mutation({variables: {id}});

        if (response.data.deleteClientDevice.length) {
            dispatch(
                showNotification(defineMessage({id: "unexpected_error", defaultMessage: "Unexpected error"}), "error"),
            );
            return;
        }

        dispatch(
            showNotification(
                defineMessage({id: "client_device_deleted", defaultMessage: "Client device deleted"}),
                "success",
            ),
        );
        close();
        onSuccess();
    }

    return (
        <Fragment>
            <IconButton
                color="secondary"
                size="small"
                onClick={open}
                data-action="delete-client-device"
                data-value={dataIdentifier}
            >
                <FontAwesomeIcon icon="trash" />
            </IconButton>
            <ConfirmDialog
                isOpen={isOpen}
                close={close}
                onConfirm={mutate}
                message={CONFIRM_MESSAGES.general_delete}
                messageVars={{name}}
                buttonIdPrefix="delete-client-device"
            />
        </Fragment>
    );
};
